/* eslint-disable no-param-reassign */
/* global localStorage */

import * as MutationTypes from '@/store/mutation-types';
import { filter, maxBy, some } from 'lodash';
import moment from 'moment';
import router from '../../router';
import AuthApi from '../../backend/api/Auth';
import UsersApi from '../../backend/api/Users';
import axios from '../../backend/axios';
import { assignHelper, fromToken } from '../helpers';

const getToken = () => {
  if (localStorage.authorization) {
    return localStorage.authorization.substr(7);
  }
  return null;
};

export default {
  namespaced: true,
  state: {
    loginEmail: null,
    user: fromToken(getToken()),
    completeUser: null,
    investmentEntities: [],
    kycs: [],
  },
  mutations: {
    [MutationTypes.LOGIN](store) {
      store.user = fromToken(getToken());
    },
    [MutationTypes.LOGOUT](store) {
      store.user = null;
    },
    [MutationTypes.STORE_LOGIN_EMAIL]: assignHelper('loginEmail'),
    [MutationTypes.SET_USER]: assignHelper('completeUser'),
    [MutationTypes.SET_INVESTMENT_ENTITIES]: assignHelper('investmentEntities'),
    [MutationTypes.SET_KYCS]: assignHelper('kycs'),
  },
  getters: {
    hasOngoingKyc({ kycs }) {
      return some(kycs, kyc => !kyc.attributes.submitted);
    },
    hasValidKyc({ kycs }) {
      if (kycs.length) {
        const lastKyc = maxBy(kycs, kyc => kyc.attributes.submittedAt);
        if (lastKyc) {
          return moment().subtract('1', 'year').isBefore(lastKyc.attributes.submittedAt) && lastKyc.attributes.signed;
        }
      }
      return false;
    },
    hasSubmittedKyc({ kycs }) {
      if (kycs.length) {
        const lastKyc = maxBy(kycs, kyc => kyc.attributes.submittedAt);
        if (lastKyc && lastKyc.attributes.submitted && !lastKyc.attributes.validated) {
          return true;
        }
      }
      return false;
    },
    hasValidatedKyc({ kycs }) {
      if (kycs.length) {
        const lastKyc = maxBy(kycs, kyc => kyc.attributes.submittedAt);
        if (lastKyc && lastKyc.attributes.validated && !lastKyc.attributes.signed) {
          return true;
        }
      }
      return false;
    },
  },
  actions: {
    login({ commit, state }, password) {
      commit(MutationTypes.LOGIN);
      return AuthApi.login(state.loginEmail, password);
    },
    logout({ commit }) {
      delete localStorage.authorization;
      commit(MutationTypes.LOGOUT);
      commit(MutationTypes.CLOSE_MENU, null, { root: true });
      commit(MutationTypes.RESET, null, { root: true });
      axios.defaults.headers.Authorization = null;
      router.push('/');
    },
    submitPasswordForgotten({ state }) {
      return AuthApi.postPasswordForgotten(state.loginEmail);
    },
    sendNewPassword(_, { password, token }) {
      const promise = AuthApi.postNewPassword(password, token);
      promise.then(() => {
        router.push('/?message=password_success');
      });
      return promise;
    },
    // checkLastKyc({ state, commit, getters }) {
    //   if (!getters.hasValidKyc && getters.hasValidatedKyc) {
    //     commit(MutationTypes.DISPLAY_VALIDATED_KYC_BANNER, null, { root: true });
    //   } else if (!state.kycs ||
    //       !state.kycs.length || getters.hasOngoingKyc) {
    //     commit(MutationTypes.DISPLAY_KYC_BANNER, null, { root: true });
    //   }
    //   return null;
    // },
    fetchCompleteUser({ commit, dispatch }) {
      const promise = UsersApi.me();
      promise.then((response) => {
        commit(MutationTypes.SET_USER, response.data.data);
        commit(MutationTypes.SET_KYCS, filter(response.data.included, {
          type: 'shortKyc',
        }));
        // dispatch('checkLastKyc');
        commit(
          `investmentEntity/${MutationTypes.SET_INVESTMENT_ENTITIES}`,
          filter(response.data.included, {
            type: 'investmentEntity',
          }),
          { root: true },
        );
      });
      return promise;
    },
  },
};
